import isEmail from 'validator/lib/isEmail';

export const passAllValidations = (arr: any) => {
  if (arr.length === 0) return true;
  return arr.every((x: any) => Object.values(x)[0] === '');
};

const validation = (
  type: string,
  value: string,
  customValidator?: any,
  customError?: string,
) => {
  if (!value) return { [type]: '此欄位為必填' };

  if (customValidator) {
    if (!customValidator(value)) {
      return { [type]: customError || '格式錯誤' };
    }
  } else {
    if (typeof strategyFactory(type, value) !== 'boolean') {
      const { message, code } = strategyFactory(type, value);
      return { [type]: message, code };
    }

    if (!strategyFactory(type, value)) {
      return { [type]: customError || '格式錯誤' };
    }
  }

  return { [type]: '' };
};

export default validation;

const strategyFactory = (type: string, value: string): any => {
  switch (type) {
    case 'email':
      return emailStrategy(value);
    case 'mobile':
      return mobileStrategy(value);
    case 'otp':
      return otpStrategy(value);
    case 'plateNumber':
      return plateNumberStrategy(value);
    case 'microElectricBikePlateNumber':
      return microElectricBikePlateNumberStrategy(value);
    case 'cardNumber':
      return creditCardNumberStrategy(value);
    case 'cardExpireDate':
      return creditCardExpireDateStrategy(value);
    case 'cardCvc':
      return creditCardCVCStrategy(value);
    case 'receiptCitizenDigitalNumber':
      return receiptCitizenDigitalNumberStrategy(value);
    case 'receiptBarcode':
      return receiptBarcodeStrategy(value);
    case 'receiptB2b':
      return receiptB2BStrategy(value);
    case 'vehicleType':
      return vehicleTypeStrategy(value);
    default:
      return true;
  }
};

const emailStrategy = (value: string) => {
  if (!isEmail(value)) return false;

  const mailDomain = value.split('@')[1].split('.')[0];
  const mailUnit = value.split('@')[1].split('.')[1];
  const isSimilarDomain =
    ['gmaol', 'gmil', 'gmai', 'gmsil', 'gma', 'gamil', 'gmal'].indexOf(
      mailDomain,
    ) !== -1;
  const isSimilarUnit = ['vom', 'te'].indexOf(mailUnit) !== -1;

  const mailError = () => {
    if (isSimilarDomain && isSimilarUnit) {
      return `"${mailDomain}","${mailUnit}"`;
    } else if (isSimilarDomain) {
      return `"${mailDomain}"`;
    } else if (isSimilarUnit) {
      return `"${mailUnit}"`;
    } else {
      return '';
    }
  };

  if (!(isSimilarDomain || isSimilarUnit)) return true;

  return {
    code: 'similar_email',
    message: `@ 後輸入的網域名稱 ${mailError()} 可能錯誤，請再次檢查 email 後送出`,
  };
};

const mobileStrategy = (value: string) => {
  return !!value.match('09[0-9]{8}');
};

const otpStrategy = (value: string) => {
  return !!value.match('[0-9]{6}');
};

const plateNumberStrategy = (value: string) => {
  return (
    value.match('^[0-9A-Z]{2}-[0-9A-Z]{2}$') !== null ||
    value.match('^[0-9A-Z]{2}-[0-9A-Z]{3}$') !== null ||
    value.match('^[0-9A-Z]{2}-[0-9A-Z]{4}$') !== null ||
    value.match('^[0-9A-Z]{3}-[0-9A-Z]{2}$') !== null ||
    value.match('^[0-9A-Z]{3}-[0-9A-Z]{3}$') !== null ||
    value.match('^[0-9A-Z]{3}-[0-9A-Z]{4}$') !== null ||
    value.match('^[0-9A-Z]{4}-[0-9A-Z]{2}$') !== null
  );
};

const microElectricBikePlateNumberStrategy = (value: string) => {
  // Check microElectricBikePlateNumber is start with two english letters and followed by 5 numbers
  return !!value.match('^[A-Z]{2}[0-9]{5}$');
};

const creditCardNumberStrategy = (value: string) => {
  return !!value.match('[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}');
};

const creditCardExpireDateStrategy = (value: string) => {
  return !!value.match('(([0-1]{1}[0-2]{1})|(0[1-9]{1}))/[0-3]{1}[0-9]{1}');
};

const creditCardCVCStrategy = (value: string) => {
  return !!value.match('[0-9]{3}');
};

const receiptCitizenDigitalNumberStrategy = (value: string) => {
  return !!value.match('[A-Z]{2}[0-9]{14}');
};

const receiptBarcodeStrategy = (value: string) => {
  return !!value.match('^/[0-9A-Z+-.]{7}$');
};

const receiptB2BStrategy = (value: string) => {
  return !!value.match('[0-9]{8}');
};

const vehicleTypeStrategy = (value: string) => {
  return !!value;
};
